/// <summary>
/// This object provides js functions for ... <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 20.9.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 20.9.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.RampArchive", $.bluaul.vcMenuTemplate, {
   
   
    _create: function () {
        var me = this;
        try {
            //console.info("START: ", moment().format("mm:ss:SSS"));
            //console.error(typeof $.widget);
            //me.deepWrapFunctions(this, "RampArchive.");
            //me.deepWrapFunctions(objArchSettings, "objArchSettings.");
            //me.deepWrapFunctions(objSignalDetails, "objSignalDetails.");
            //me.deepWrapFunctions(objSignalPlaus, "objSignalPlaus.");
            //me.deepWrapFunctions(objSignalTickets, "objSignalTickets.");
            //me.deepWrapFunctions(objSignalListItems, "objSignalListItems.");
            //me.deepWrapFunctions(objArchExport, "objArchExport.");
            //me.deepWrapFunctions(objArchSettings, "objArchSettings.");
            //me.deepWrapFunctions(objChartClickHandler, "objChartClickHandler.");
            //me.deepWrapFunctions(objChartTempHistory, "objChartTempHistory.");
            //me.deepWrapFunctions(objDataCenter, "objDataCenter.");

            me.element.html("");
            me.options.invoke.vcvid = 341;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
          
        } catch (e) { me.writeError('_create', e); return false;}
        return true;
    },

    _initVariables: function () {
        var me = this;
        try {
            me._super();

            me.settings.defaultChart = "archive";
            me.settings.menu.top.showMenuAsDropdown = true;
            me.settings.menu.top.interval.default = 1;
            me.settings.toggleView = true;
            me.settings.signalSelection = true;
            me.settings.showAllSignalsAtStart = false;
            me.settings.enableFilterForInvalidSignals = true;
            me.settings.hideSignalsWithNotAllowedSettings = false;
            me.settings.showArchiveRules = true;
            me.settings.enableMeta = true;

            me.settings.menu.top.interval.enabled = true;
            me.settings.menu.top.datatype.enabled = true;
            me.settings.menu.top.charts.enabled = true;
            me.settings.menu.top.opt.enabled = true;
            me.settings.menu.top.opt.showTags = true;
            me.settings.menu.top.opt.showRules = true;
            me.settings.menu.top.opt.showInterventions = true;
            me.settings.menu.top.opt.showTickets = true;

            me.settings.menu.top.export.enabled = true;
            me.settings.menu.top.export.showFavorites = true;
            me.settings.menu.top.export.showShare = true;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = false;
            me.settings.menu.main.date.enabled = true;
            me.settings.menu.main.dateComparison.enabled = true;
            me.settings.menu.main.rampResolution.enabled = true;
            me.settings.menu.main.rampOptions.enabled = true;
            me.settings.menu.main.rampTempCharts.enabled = true;
            me.settings.menu.main.specificOptions.enabled = false;
            me.settings.menu.main.history.enabled = true;
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = true;

       
          
        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },

    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {


            me._super();

            $.each(me.settings.charts, function () { this.enabled = true });
            me.settings.charts.filter(function (item) { return item.id == "heatmap" })[0].enabled = false;
            me.settings.charts.filter(function (item) { return item.id == "subsignal" })[0].enabled = false;
            me.settings.charts.filter(function (item) { return item.id == "dataflow" })[0].enabled = false;
            me.settings.charts.filter(function (item) { return item.id == "docu" })[0].enabled = false;

            me.settings.charts.filter(function (item) { return item.id == "plauslist" })[0].enabled = false;
           
            me.settings.charts.filter(function (item) { return item.id == "configs" })[0].enabled = false;
            me.settings.charts.filter(function (item) { return item.id == "status" })[0].enabled = false;
            me.settings.charts.filter(function (item) { return item.id == "meterreadings" })[0].enabled = false;

            me.settings.charts.filter(function (item) { return item.id == "onlinelist" })[0].enabled = false;
            me.settings.charts.filter(function (item) { return item.id == "mr-adjustments" })[0].enabled = false;


        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },


});

jQuery.widget("bluaul.RampArchiveSimple", $.bluaul.vcMenuTemplate, {


    _create: function () {
        var me = this;
        try {
          
            me.element.html("");
            me.options.invoke.vcvid = 346;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();

        } catch (e) { me.writeError('_create', e); return false; }
        return true;
    },

    _initVariables: function () {
        var me = this;
        try {
            me._super();

            me.settings.defaultChart = "archive";
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.default = 1;
            me.settings.toggleView = true;
            me.settings.signalSelection = true;
            me.settings.showAllSignalsAtStart = false;
            me.settings.enableFilterForInvalidSignals = true;
            me.settings.hideSignalsWithNotAllowedSettings = false;
            me.settings.showArchiveRules = false;
            me.settings.enableMeta = false;

            me.settings.menu.top.interval.enabled = true;
            me.settings.menu.top.datatype.enabled = true;
            me.settings.menu.top.charts.enabled = true;
            me.settings.menu.top.datatype.showPrice = false;
            me.settings.menu.top.datatype.showCo2 = false;
            me.settings.menu.top.datatype.showAddTemp = false;
            me.settings.menu.top.datatype.showDetails = false;
            me.settings.menu.top.datatype.showDataCenter = false;

            me.settings.menu.top.opt.enabled = false;
            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;

            me.settings.menu.top.export.enabled = false;
            me.settings.menu.top.export.showFavorites = true;
            me.settings.menu.top.export.showShare = true;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = false;
            me.settings.menu.main.date.enabled = true;
            me.settings.menu.main.dateComparison.enabled = true;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = false;
            me.settings.menu.main.history.enabled = true;
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = false;



        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },

    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {


            me._super();

            $.each(me.settings.charts, function () { this.enabled = false });
            me.settings.charts.filter(function (item) { return item.id == "archive" })[0].enabled = true;
            me.settings.charts.filter(function (item) { return item.id == "rawdata" })[0].enabled = true;
            me.settings.charts.filter(function (item) { return item.id == "zst" })[0].enabled = true;
          
            $.each(me.settings.iconCharts, function () { this.enabled = false });


        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },


});

jQuery.widget("bluaul.RampArchiveMobileTest", $.bluaul.RampArchive, {



    _initVariables: function () {
        var me = this;
        try {
            me._super();
            me.settings.menu.top.showMenuAsDropdown = true;
            me.settings.mobile = true;

        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    }


});



